export const getParams = () =>
  typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search)
    : undefined;
